<template>
  <div class="default-layout-component">
    <div class="default-layout-component__inner">
      <DefaultSecondaryNavigation class="default-layout-component__inner-secondary-navigation" />
      <DefaultHeader
        class="default-layout-component__inner-header"
        :class="{
          'default-layout-component__inner-header--scrolled': headerScrolled,
        }"
      />
      <main class="default-layout-component__main">
        <slot />
      </main>
    </div>
    <AppOverlay />
    <AppToastWrapper />
    <AppWave
      v-if="showFooterWave"
      primary-color
      :show-bottom="false"
    >
      <AppFooter />
    </AppWave>
    <AppFooter v-else />
    <ClientOnly>
      <CookieBanner />
    </ClientOnly>
  </div>
</template>

<script setup>
  defineProps({
    showFooterWave: {
      type: Boolean,
      default: false,
    },
  })
  const headerScrolled = ref(false)

  onMounted(() => {
    handleScroll()
    document.addEventListener('scroll', handleScroll)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('scroll', handleScroll)
  })

  function handleScroll() {
    if (window.scrollY < 100 && headerScrolled.value) {
      headerScrolled.value = false

      return
    }

    if (window.scrollY >= 100 && !headerScrolled.value) {
      headerScrolled.value = true
    }
  }
</script>

<style lang="scss" scoped>
  // <main> landmark wrapper — kept transparent to layout so it behaves exactly like the
  // previously-unwrapped slot content (full-width flex item, children flow as before).
  .default-layout-component__main {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .default-layout-component__inner {
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    @include breakpoint(desktop) {
      background-repeat: no-repeat;
      background-image: url('/images/homepage-shape-grey.svg');
      background-position: top center;
    }
  }

  .default-layout-component__inner-secondary-navigation {
    display: none;

    @include breakpoint(desktop) {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      max-width: var(--max-width-content);
      padding: 0 var(--content-padding);
      margin: 12px auto;
    }
  }

  .default-layout-component__inner-header {
    position: sticky;
    top: 0;
    z-index: 2;
    width: 100%;
    max-width: var(--max-width-content);
    padding: 0 var(--content-padding);
    margin: 0 auto;
    background: white;
    border-bottom: 1px solid var(--color-lighter-gray);

    @include breakpoint(desktop) {
      background: transparent;
      border: none;
    }
  }

  .default-layout-component__inner-header--scrolled {
    box-shadow:
      rgba(31, 39, 96, 0.2509803922) 0 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0 30px 60px -30px;

    @include breakpoint(desktop) {
      box-shadow: none;
    }

    &:before {
      @include breakpoint(desktop) {
        content: '';
        top: 0;
        height: 100%;
        z-index: -1;
        box-shadow:
          rgba(31, 39, 96, 0.2509803922) 0 50px 100px -20px,
          rgba(0, 0, 0, 0.3) 0 30px 60px -30px;

        left: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        position: relative;
        right: 50%;
        width: 100vw;

        background-position-x: center;
        background-color: white;
        background-position-y: -100px;
        background-repeat: no-repeat;
        background-image: url('/images/homepage-shape-grey.svg');
      }
    }
  }
</style>
